import React from 'react';
import { TableRow, TableCell } from '@mui/material';
import SalesStaticTableCell from './SalesStaticTableCell';

const SalesStaticsHeadquarterRow = ({ headerRows, data }) => {
  if (!headerRows || !data) {
    return null;
  }

  return (
    data &&
    data.map((hq, hIndex) => {
      return (
        <TableRow key={hIndex}>
          <TableCell align="center" sx={{ width: 200 }}>
            {hq.name}
          </TableCell>
          <SalesStaticTableCell data={hq} headerRows={headerRows} />
        </TableRow>
      );
    })
  );
};

export default SalesStaticsHeadquarterRow;
